import React from 'react';

import style from './loading.css';

const Loading = () => (
  <div className={style.loadingWrapper}>
    <div className={style.loading} />
    <div className={style.message}>Just a second, we&apos;re adding some detail to your Scene</div>
  </div>
);

export default Loading;
